export default "__VITE_ASSET__DvvfhSro__"